import React from 'react';
import { CTAButton } from './CTAButton';
import { SectionHeading } from './SectionHeading';
import { tools } from '../data/audit';
export function Tools() {
  return <section className="bg-cream-100 px-4 py-14 sm:px-6 sm:py-20" data-id="element-303" data-mp="17eji01d7619s">
      <div className="mx-auto w-full max-w-5xl" data-id="element-304" data-mp="17g4gg22mu4cx">
        <SectionHeading eyebrow="Included with your access" title="Plus 30+ practical clinical tools" data-id="element-305" data-mp="1cd4je446qqzt" />

        <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-306" data-mp="204iak6qlogj7">
          {tools.map(t => <article key={t.title} className="flex flex-col rounded-2xl bg-white p-5 ring-1 ring-navy-900/8" data-id="element-307" data-mp="244answqxvauw">
              <span className="text-2xl" aria-hidden="true" data-id="element-308" data-mp="1vc8s1brteiqy">
                {t.emoji}
              </span>
              <h3 className="mt-3 text-sm font-extrabold uppercase tracking-[0.08em] text-navy-900" data-id="element-309" data-mp="2j1jk84v3n4th">
                {t.title}
              </h3>
              <p className="mt-2 text-[14px] leading-relaxed text-navy-700/80" data-id="element-310" data-mp="2nu4a4vavwxrq">
                {t.text}
              </p>
            </article>)}
        </div>

        <div className="mx-auto mt-10 max-w-3xl rounded-3xl bg-navy-900 p-6 sm:p-8" data-id="element-311" data-mp="2l13slm81s3nj">
          <h3 className="text-center font-display text-2xl font-bold leading-tight text-cream-50 sm:text-3xl" data-id="element-312" data-mp="2ys0fqxj7fsn7">
            This isn’t about memorizing more.
          </h3>
          <p className="mt-3 text-center text-base text-cream-100/80 sm:text-lg" data-id="element-313" data-mp="38pn03zj9wcek">
            It’s about having a process to review what you already know.
          </p>
          <div className="mt-6 grid gap-3 sm:grid-cols-2" data-id="element-314" data-mp="33qaefi451bdk">
            <div className="rounded-2xl bg-white/5 p-4 text-center" data-id="element-315" data-mp="3hql62nd9utzs">
              <p className="text-[11px] font-bold uppercase tracking-[0.14em] text-cream-100/50" data-id="element-316" data-mp="3cr8ks721tuzb">
                Instead of asking
              </p>
              <p className="mt-2 font-display text-base italic text-cream-100/70 sm:text-lg" data-id="element-317" data-mp="1nd3hcx14rr36">
                “What am I supposed to remember?”
              </p>
            </div>
            <div className="rounded-2xl bg-gold-500 p-4 text-center" data-id="element-318" data-mp="3ig9xzxhg7btz">
              <p className="text-[11px] font-bold uppercase tracking-[0.14em] text-navy-950/60" data-id="element-319" data-mp="3nejuqcitmkhp">
                You can ask
              </p>
              <p className="mt-2 font-display text-base font-bold italic text-navy-950 sm:text-lg" data-id="element-320" data-mp="3scv28gln8iwr">
                “Which of the 7 critical areas do I need to review?”
              </p>
            </div>
          </div>
          <p className="mt-6 text-center text-sm text-cream-100/70" data-id="element-321" data-mp="58ommvwxh8gz">
            Instead of jumping between books, courses, notes, screenshots and
            saved posts — you have{' '}
            <strong className="font-bold text-gold-300" data-id="element-322" data-mp="f02vhuarrkms">
              one structured audit system
            </strong>
            .
          </p>
        </div>

        <div className="mt-10" data-id="element-323" data-mp="nzy9s7zmfvr1">
          <CTAButton label="I want the Complex Rehab Case Audit™" subLabel="One-time payment of $27" data-id="element-324" data-mp="o0r5mdx1l0ue" />
        </div>
      </div>
    </section>;
}